import { DaoModel } from '@dynameat/models';
import { ForecastDemandService } from './forecastDemandService';

export class ForecastDemandSaleRate extends DaoModel {
  constructor(guid, services) {
    super(guid);
    this.services = services || [];
  }

  static toInstance(props = {}) {
    const services = ForecastDemandService.toInstanceList(props.services) || [];
    return new ForecastDemandSaleRate(props.guid, services);
  }

  serialize() {
    return {
      ...super.serialize(),
      services: this.services.map((service) => service.serialize())
    };
  }

  hasMatchingServices(serviceGuid) {
    return this.services.some((service) => service.isInService(serviceGuid));
  }
}
